import { BaggageType } from '@websky/graphql';
import * as React from 'react';
import { CdnIcon } from '@shared/ui';
import CdnImage from '../../CdnImage/CdnImage';
const ICON_BY_BAGGAGE_TYPE = {
    [BaggageType.CarryOn]: 'Baggage/Cabin',
    [BaggageType.CheckedBaggage]: 'Baggage/Checked-in',
    [BaggageType.BaggageExcess]: 'Baggage/Overweight',
    [BaggageType.HandLuggageExcess]: 'Baggage/Cabin Upsize',
    [BaggageType.PetInCabin]: 'Baggage/Pet in cabin',
    [BaggageType.PetInHold]: 'Baggage/Pet in cargo',
    [BaggageType.PetInHandCarrier]: 'Baggage/Pet in saloon',
    [BaggageType.SportingEquipment]: 'Baggage/Sport Equipment',
    [BaggageType.SurfingEquipment]: 'Baggage/Serfing',
    [BaggageType.Ski]: 'Baggage/Ski',
    [BaggageType.FishingEquipment]: 'Baggage/Fishing',
    [BaggageType.Bike]: 'Baggage/Byke',
    [BaggageType.MusicalInstrument]: 'Baggage/Musical inst'
};
const BaggageIcon = React.memo(({ baggageType, rfisc }) => {
    if (!rfisc && !baggageType) {
        return null;
    }
    const iconName = baggageType ? ICON_BY_BAGGAGE_TYPE[baggageType] : undefined;
    if (rfisc) {
        return (React.createElement(CdnImage, { path: `icons/baggage/${rfisc}.svg`, contentRepo: true, emptyImage: baggageType ? (React.createElement(CdnImage, { path: `icons/baggage/${baggageType}.svg`, contentRepo: true, emptyImage: iconName ? React.createElement(CdnIcon, { icon: iconName }) : undefined })) : undefined }));
    }
    return (React.createElement(CdnImage, { path: `icons/baggage/${baggageType}.svg`, contentRepo: true, emptyImage: iconName ? React.createElement(CdnIcon, { icon: iconName }) : undefined }));
});
BaggageIcon.displayName = 'BaggageIcon';
export default BaggageIcon;
